import { AuthMethod, creditAssessment, } from "@wayke-se/ecom";
export default (caseId, callback) => {
    const request = {
        caseId,
        method: AuthMethod.QrCode,
    };
    creditAssessment.signCase(request).then(callback).catch(callback);
};
